import { invisibleClass } from "../config.js";

const delayClass = 'delay-500';
const noOpacityClass = 'opacity-0';

export const initializeHomeMedia = () => {
    const entryVideos = document.querySelectorAll('.js-entry-video');
    if (entryVideos.length === 0) {
        return;
    }

    entryVideos.forEach(entryVideo => {
        entryVideo.addEventListener('mouseenter', (event) => {
            handleExpandMedia(entryVideo.style, event);
        });

        entryVideo.addEventListener("mouseleave", (event) => {
            handleShrinkMedia(entryVideo.style, event);
        });
    });

}

const handleExpandMedia = (entryVideoStyles, event) => {
    const expandX = 152;
    const pagePadding = 64;

    const boundingRect = event.target.getBoundingClientRect();
    const leftAllowance = boundingRect.left - pagePadding;
    const rightAllowance = window.innerWidth - boundingRect.right - pagePadding;

    if (leftAllowance < expandX) {
        const shift = expandX - (leftAllowance);
        entryVideoStyles.left = `-${expandX - shift}px`;
        entryVideoStyles.right = `-${expandX + shift}px`;

    } else if (rightAllowance < expandX) {
        const shift = expandX - (rightAllowance);
        entryVideoStyles.left = `-${expandX + shift}px`;
        entryVideoStyles.right = `-${expandX - shift}px`;

    } else {
        entryVideoStyles.insetInline = `-${expandX}px`;
    }

    entryVideoStyles.insetBlock = '-88px';
    entryVideoStyles.width = 'auto';
    entryVideoStyles.maxHeight = 'none';
    entryVideoStyles.zIndex = '1';

    const entryTitle = findEntryTitle(event);
    if (entryTitle) {
        entryTitle.classList.add(delayClass);
        entryTitle.classList.remove(invisibleClass);
        entryTitle.classList.remove(noOpacityClass);
    }
}

const handleShrinkMedia = (entryVideoStyles, event) => {
    entryVideoStyles.left = 0;
    entryVideoStyles.right = 0;
    entryVideoStyles.insetBlock = 0;
    entryVideoStyles.maxHeight = 'auto';
    entryVideoStyles.zIndex = 0;

    const entryTitle = findEntryTitle(event);
    if (entryTitle) {
        entryTitle.classList.remove(delayClass);
        entryTitle.classList.add(invisibleClass);
        entryTitle.classList.add(noOpacityClass);
    }
}

const findEntryTitle = (event) => event.target.parentElement.querySelector('.js-entry-title');
